import { createSelector } from 'reselect';

import { RootReducer } from 'types/store';

export const selectSession = (state: RootReducer) => state.session;

const selectMainSessionId = createSelector(selectSession, (session) => session.mainSessionId);

export { selectMainSessionId };
